export const RuleStatusLabels = {
    SUCCEEDED: "Passed",
    FAILED: "Failed",
    NOT_APPLICABLE: "Not Applicable",
    BACKLOG: "Backlog",
    NOT_EVALUATED: "Not Evaluated",
};

export const RuleStatusMap = new Proxy(RuleStatusLabels, {
    get: (target, prop) => {
        return target?.[prop]??target.FAILED;
    }
});
